export type ReportType = 'discussion' | 'reply'

export type ReportReason = 'spam' | 'harassment' | 'inappropriate' | 'other'

export type ReportStatus = 'pending' | 'resolved' | 'dismissed'

export interface Report {
  id: string
  type: ReportType
  discussionId: string
  replyId: string | null
  targetUserId: string
  reporterId: string
  reason: ReportReason
  detail: string
  contentSnapshot: string
  createdAt: Date
  status: ReportStatus
  handledAt?: Date
  handledBy?: string
}

export const ReportTypeLabels: Record<ReportType, string> = {
  discussion: '貼文',
  reply: '回覆',
}

export const ReportReasonLabels: Record<ReportReason, string> = {
  spam: '垃圾訊息',
  harassment: '騷擾或霸凌',
  inappropriate: '不當或冒犯內容',
  other: '其他',
}

export const ReportStatusLabels: Record<ReportStatus, string> = {
  pending: '待處理',
  resolved: '已處理',
  dismissed: '已駁回',
}

export const ReportStatusColors: Record<
  ReportStatus,
  'warning' | 'success' | 'default'
> = {
  pending: 'warning',
  resolved: 'success',
  dismissed: 'default',
}
